// @flow

export default class ValueHelper {
    /**
     * Returns true if value is null, undefined, empty string
     * or whitespace-only string.
     */
    static isEmpty(value: any): boolean {
        return !value || (typeof value === "string" && /^\s*$/.test(value));
    }
}



// WEBPACK FOOTER //
// ./src/app/util/ValueHelper.js